import React from 'react';
import { Spin, Empty } from 'antd';
import { useShutdownAccesses } from '../../../../../../shared/lib/hooks/useShutdownAccesses';
import { useFilterAttachmentsBySearch } from '../../utils/useFilterAttachmentsBySearch';
import useCardPagination from '../../../../../../../../hooks/useCardPagination';
import Card, { CardHeader } from '../../../../../../../../components/Card';
import SearchField from '../../../../../../../../components/SearchField/SearchField';
import AttachmentList from '../AttachmentList/AttachmentList';
import UploadBtn from '../UploadBtn/UploadBtn';
import styles from './PopoverContent.module.scss';

const maxScreenAmount = 4;

const PopoverContent = ({ attachments, loading, shutdownId }) => {
  const { canDelete, canChange } = useShutdownAccesses();

  const { filteredAttachments, search, onSearchChange } =
    useFilterAttachmentsBySearch({ attachments });

  const { shownItems, pagination } = useCardPagination(
    filteredAttachments,
    maxScreenAmount
  );

  const showSearchAndPagination = attachments?.length > maxScreenAmount;

  return (
    <Spin spinning={loading || false}>
      <Card className={styles.card}>
        <CardHeader
          title={`Вложения для отключения ${shutdownId}`}
          action={showSearchAndPagination ? pagination : null}
          titleProps={{ className: styles.cardTitle }}
        />
        {attachments?.length ? (
          <>
            {showSearchAndPagination && (
              <SearchField
                className={styles.search}
                placeholder="Поиск по названию вложения"
                value={search}
                onChange={onSearchChange}
              />
            )}

            <AttachmentList
              shownItems={shownItems}
              attachments={attachments}
              shutdownId={shutdownId}
              canDelete={canDelete}
            />
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет вложений"
          />
        )}

        {canChange && <UploadBtn shutdownId={shutdownId} />}
      </Card>
    </Spin>
  );
};

export default PopoverContent;
